import { useEffect, useState } from 'react';
import { ChevronUp } from 'lucide-react';

const DEFAULT_THRESHOLD_PX = 300;

type ScrollToTopProps = {
  /** Pixels de scroll vertical antes de exibir o botão. */
  threshold?: number;
};

/**
 * Botão flutuante "Voltar ao topo" para a lista de conversores.
 * Escuta scroll da window e limpa o listener no unmount.
 */
export default function ScrollToTop({ threshold = DEFAULT_THRESHOLD_PX }: ScrollToTopProps) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      const y = window.scrollY || window.pageYOffset || 0;
      setVisible(y > threshold);
    };

    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, [threshold]);

  const handleClick = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      aria-label="Voltar ao topo"
      title="Voltar ao topo"
      tabIndex={visible ? 0 : -1}
      className={[
        'fixed z-50 bottom-6 right-4 sm:right-6 mb-[env(safe-area-inset-bottom)]',
        'inline-flex items-center justify-center text-[#660055]',
        'hover:text-[#993399] hover:-translate-y-0.5 focus:outline-none focus-visible:ring-2 focus-visible:ring-[#993399]',
        'transition-all duration-300',
        visible ? 'opacity-100' : 'opacity-0 pointer-events-none',
      ].join(' ')}
    >
      <ChevronUp className="w-7 h-7" aria-hidden="true" />
    </button>
  );
}
